// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + chunkId + ".js?v=" + {"2441":"fc741cf57e9647f370a3","3920":"d2965aff947ea8ac373f","5528":"f8c82ca706bbd1c68212","5862":"7b9b02dc0a1b898066ef","7462":"3e847bb77a42cd0d3af3","7874":"5d0f14697282cbdd7841","8057":"2c8f7e35c56e047ba73f"}[chunkId] + "";
};